export const provincies = [
  { code: 22, label: "Drenthe", country: 'nl' },
  { code: 27, label: "Noord-Holland", country: 'nl' },
  { code: 25, label: "Gelderland", country: 'nl' },
  { code: 21, label: "Friesland", country: 'nl' },
  { code: 28, label: "Zuid-Holland", country: 'nl' },
  { code: 23, label: "Overijssel", country: 'nl' },
  { code: 24, label: "Flevoland", country: 'nl' },
  { code: 30, label: "Noord-Brabant", country: 'nl' },
  { code: 26, label: "Utrecht", country: 'nl' },
  { code: 20, label: "Groningen", country: 'nl' },
  { code: 31, label: "Limburg", country: 'nl' },

  // TODO: Fix uitzondering
  { code: 0, label: "Belgie", country: 'be' }
]